import { combineReducers } from 'redux';

import confrontarDigitais from './confrontarDigitais/reducer';
import consultarTemporalidade from './consultarTemporalidade/reducer';

export default combineReducers({
	confrontarDigitais,
	consultarTemporalidade,
});
